<template>
  <div class="fullheight">
    <eco-table
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :quick-search-props="[
        { prop: 'dwd_portal_sys_logs_new.ope_name_', label: '操作名称' },
        { prop: 'dwd_portal_sys_logs_new.executor_', label: '执行人' },
        { prop: 'dwd_portal_sys_logs_new.ip_', label: '客户端IP' },
        { prop: 'dwd_portal_sys_logs_new.req_url_', label: '请求地址' }
      ]"
      :default-sorter="[{ direction: 'DESC', property: 'ID_' }]"
      ref="ecoTable"
      :show-export="false"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="openDashboard()" type="primary">可视化</el-button>
          <fe-delete-button :url="deleteUrl" :htTable="$refs.ecoTable" @after-delete="afterDelete" class="marginLeft16">删除</fe-delete-button>
        </el-button-group>
      </template>

      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="opeName" label="操作名称" :sortable="true" :show-overflow-tooltip="true"></eco-table-column>
        <eco-table-column prop="executionTime" label="执行时间" :sortable="true" width="200" />
        <eco-table-column prop="executor" label="执行人" width="160" />
        <eco-table-column prop="ip" label="客户端IP" width="120" />
        <eco-table-column prop="reqUrl" label="请求地址" width="300" />
        <eco-table-column prop="logType" label="日志类型" width="100" :filters="typeArray">
          <template v-slot="{ row }">
            <el-tag v-show="row.logType == s.value" type="info" v-for="s in typeArray" :key="s.value">{{ s.text }}</el-tag>
          </template>
        </eco-table-column>
        <eco-table-column prop="moduleType" label="模块类型" width="100"> </eco-table-column>
      </template>
    </eco-table>

    <!-- 嵌入仪表盘 -->
    <el-drawer :wrapperClosable="false" :close-on-press-escape="false" :visible.sync="drawer" direction="ttb" class="drawer-panel">
      <iframe :src="dashBoardSrc" width="100%" height="100%" frameborder="0" scrolling="auto"> </iframe>
    </el-drawer>
  </div>
</template>
<script>
import req from '@/request.js'
import { mapState } from 'vuex'

export default {
  components: {},
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      curRow: {},
      dialogVisible: false,
      statusArray: [
        { text: '用户微服务', value: 'uc-eureka' },
        { text: '配置微服务', value: 'portal-eureka' },
        { text: '表单微服务', value: 'form-eureka' },
        { text: '流程模型微服务', value: 'bpm-model-eureka' },
        { text: '流程运行微服务', value: 'bpm-runtime-eureka' }
      ],
      typeArray: [
        { text: '操作日志', value: '操作日志' },
        { text: '登录日志', value: '登录日志' },
        { text: '异常日志', value: '异常日志' }
      ],
      drawer: false,
      dashBoardSrc: ''
    }
  },
  computed: {
    deleteUrl: function () {
      return window.context.log + '/sysLogs/removes'
    },
    ...mapState({
      currentDashboard: (state) => state.menu.currentDashboard
    })
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
    },
    openDetail(row) {
      this.curRow = row
      this.dialogVisible = true
    },
    loadData(param, cb) {
      req
        .post(req.getContext().data + '/sys/sys_logs/list', param)
        .then((data) => {
          let response = data.data
          this.data = response.rows
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          }
        })
        .finally(() => cb())
    },
    afterDelete() {
      this.$refs.ecoTable.load()
    },
    reinvoke(id) {
      let this_ = this
      req.post(req.getContext().portal + '/portal/messageLog/v1/reinvoke/' + id).then(function (response) {
        let data = response.data
        if (data.state) {
          this_.$message.success(data.message)
          this_.$refs.ecoTable.load()
        } else {
          this_.$message.fail(data.message)
        }
      })
    },
    signSuccess(id) {
      let this_ = this
      req.post(req.getContext().portal + '/portal/messageLog/v1/signSuccess/' + id).then(function (response) {
        let data = response.data
        if (data.state) {
          this_.$message.success(data.message)
          this_.$refs.ecoTable.load()
        } else {
          this_.$message.fail(data.message)
        }
      })
    },
    //点击打开仪表盘
    openDashboard() {
      console.info(this.currentDashboard)
      const tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
      if (tenantId && this.currentDashboard) {
        let dashBoardUrl = '${data}/open/dashBoard/open'
        let dashboardParam = {
          dashBoardUrl: this.currentDashboard,
          tenantId: tenantId,
          projectId: ''
        }
        this.$http.post(dashBoardUrl, dashboardParam).then((resp) => {
          if (resp.data) {
            this.drawer = true
            console.log('url: ' + resp.data.value)
            this.dashBoardSrc = resp.data.value
          }
        })
      } else {
        this.$message.warning('未配置仪表盘跳转链接。')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/element-variables.scss';

.aside-width {
  width: $--aside-width !important;
}
.drawer-panel {
  width: 87.85%;
  height: 285%;
  left: 12%;
  top: 11%;
}
.el-drawer__header {
  margin-bottom: 0;
  bottom: 0;
  padding: 0;
}
</style>
